import { useEffect, useState } from "react";
import {
  Box,
  useMediaQuery,
  Card,
  Theme,
  lighten,
} from "@mui/material";
import { Outlet } from "react-router-dom";
import { SideNav } from "../components/SideNav";
import { AppHeader } from "../components/AppHeader";

export const AppLayout = ({ title }: { title: string }) => {
  const isMdUp = useMediaQuery("(min-width:900px)");
  const [drawerOpen, setDrawerOpen] = useState(isMdUp);

  useEffect(() => {
    setDrawerOpen(isMdUp);
  }, [isMdUp]);

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        backgroundColor: (theme: Theme) =>
          theme.palette.mode === "dark"
            ? lighten(theme.palette.background.default, 0.05)
            : theme.palette.action.hover,
      }}
    >
      <SideNav onClose={() => setDrawerOpen(!drawerOpen)} open={drawerOpen} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 1.5,
          height: "100%",
          overflow: "hidden",
        }}
      >
        <Card
          variant="outlined"
          sx={{
            border: "none",
            height: "100%",
            borderRadius: 1.5,
            boxShadow: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <AppHeader
            onMenu={() => setDrawerOpen(!drawerOpen)}
            drawerOpen={drawerOpen}
            title={title}
          />

          <Box
            sx={{
              flex: 1,
              overflow: "auto",
              p: 0,
              width: "100%",
            }}
          >
            <Outlet />
          </Box>
        </Card>
      </Box>
    </Box>
  );
};
